export const RELATED_ADJUSTMENTS_ISSUED_COPY =
  "Related adjustments issued after 4/18/2024 will now appear in the earnings history on your listings. They have always been included in your returns information.";
